module.exports = __webpack_public_path__ + "static/media/js3.5dd173ba.jpg";